function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from "react";
import PropTypes from "prop-types";
import * as OverlayContext from "../OverlayContext";
import Button from "../../Misc/Buttons/DefaultBlueButton";

var OverlaySettingsModal = function (_React$Component) {
  _inherits(OverlaySettingsModal, _React$Component);

  function OverlaySettingsModal() {
    _classCallCheck(this, OverlaySettingsModal);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  OverlaySettingsModal.prototype.render = function render() {
    var OverlayContext = this.props.OverlayContext;
    var itemTimeSettingsForm = OverlayContext.state.itemTimeSettingsForm;
    return itemTimeSettingsForm && React.createElement("div", {
      className: "modal modal--style-default modal--type-save-script is-active"
    }, React.createElement("form", {
      className: "modal__window",
      onSubmit: function onSubmit(e) {
        e.preventDefault();
        OverlayContext.confirmOverlaySettings();
      }
    }, React.createElement("h3", {
      className: "modal__title"
    }, itemTimeSettingsForm.id ? "Update item" : "Add item to this position?"), React.createElement("div", {
      className: "modal__form"
    }, React.createElement("div", {
      className: "form form--style-account"
    }, React.createElement("div", {
      className: "form__container"
    }, React.createElement("input", {
      autoFocus: true,
      type: "number",
      step: "0.01",
      className: "form__input",
      value: itemTimeSettingsForm.start,
      placeholder: "start time",
      min: 0,
      onChange: function onChange(e) {
        return OverlayContext.changeItemParam("start", parseFloat(e.target.value));
      }
    }), React.createElement("div", {
      className: "form__caption"
    }, "Start time"), React.createElement("input", {
      type: "number",
      step: "0.01",
      className: "form__input",
      placeholder: "duration",
      value: itemTimeSettingsForm.duration,
      min: 1,
      onChange: function onChange(e) {
        return OverlayContext.changeItemParam("duration", parseFloat(e.target.value));
      }
    }), React.createElement("div", {
      className: "form__caption"
    }, "Duration")))), React.createElement("div", {
      className: "modal__buttons"
    }, React.createElement("button", {
      className: "button button--style-default button--size-m button--color-ghost button--width-s",
      onClick: OverlayContext.closeItemTimeSettingsEditor,
      type: "button"
    }, "cancel"), React.createElement(Button, {
      className: "button--width-s",
      type: "submit"
    }, "save"))));
  };

  return OverlaySettingsModal;
}(React.Component);

OverlaySettingsModal.propTypes = process.env.NODE_ENV !== "production" ? {
  OverlayContext: PropTypes.object.isRequired
} : {};
export default OverlayContext.consumeContext(OverlaySettingsModal);